var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mt-3 text-center",attrs:{"show":"","variant":"info"}},[_vm._v(" "+_vm._s(_vm.$t('pages.new_booking.redirect_return_without_cart'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }